import axios from "axios";
import i18n from "../../../../../i18n";

// Constants
const SET_PARTICIPANTS_COUNT = "SET_PARTICIPANTS_COUNT";
const RESET_STATE = "RESET_STATE";

// Acessors
const getTotalParticipants = (state) => state?.total;

// Default state
const initialState = {
  total: null,
};

export const totalParticipantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PARTICIPANTS_COUNT:
      const { data } = action;
      return {
        total: data,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

const fetchTotalParticipants = (type) => (dispatch) =>
  axios
    .get("/api/participant/count")
    .then(({ data }) => {
      dispatch({
        type: SET_PARTICIPANTS_COUNT,
        data: data,
      });
    })
    .catch(() => {
      return Promise.reject(
        i18n.t("errorText.dietDiary.dailyTargets.history.get")
      );
    });

export const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    total: getTotalParticipants(state),
  };
};

export const mapDispatchToProps = {
  fetchTotalParticipants,
  resetState,
};
